import React, {useContext} from 'react';
import logo from './../images/EDVES-LOGO 2.png';
import defaultPic from './../images/defaultPic.png';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import shrinkIcon from './../images/shrinkIcon.png';
import HamburgerSvg from '../svg/HamburgerSvg';
import { DataContext } from '../context/DataContext';

const tabItems = [
    {
        label: "Locker",
        path: "locker"
    },
    {
        label: "CBT",
        path: "cbt"
    },
    {
        // label:  localStorage.getItem('schoolDomain') === 'demo.edves.net' ? "Chatroom" : '',
        label: "Chatroom" ,
        path: "chatroom"
    }
];

const TabItemContainer = ({ children }) => (
    <div>{children}</div>
);


const TabItem = ({item}) => {
  const dataContext = useContext(DataContext);
  console.log(dataContext.hideSidebar)
    const location = useLocation();
    const isCurrentRoute = location.pathname === `/${item.path}`;
    const classes = classNames({
        'px-4 mx-4 -mb-2 py-1 leading-4 text-sm text-gray-100 flex flex-column justify-center items-end font-semibold': true,
        'text-gray-200 hover:text-blue-100 transform transition ease-in-out duration-100': !isCurrentRoute,
        'text-blue-100': isCurrentRoute
    });
    const showBar = classNames({
        'w-24 mx-4 -mb-2 h-1 inline-block': !isCurrentRoute,
        'w-24 mx-4 -mb-2 h-1 bg-blue-100 inline-block rounded-t': isCurrentRoute
    })

    const BottomBar = () => (
      <span className={showBar} />
    );
    
    return (
        <div>
            <Link to={item.path} className={classes}>
              {item.label}
            </Link>
            {item.path === 'chatroom' &&  <BottomBar />}          
            {/* {item.path === 'chatroom' && window.location.host === 'demo.edves.net' ? '' : <BottomBar />}           */}
        </div>
    )
}


const Tabs = () => {
  return (
    <>
      { tabItems.map((items, index) => (
        <>
          <TabItemContainer className='flex flex-column' key={index}>
            <TabItem item={items} />
          </TabItemContainer>
        </>
      ))}
    </>
  )
}

const CbtNavbar = () => {
  const dataContext = useContext(DataContext);
  const showMenu = dataContext.showMenu;
  const studentPassport = JSON.parse(localStorage.getItem('studentInfo'))[0].studentpassport;

  const setDisplaySidebar = () => {
    dataContext.setShowMenu(!showMenu);
    dataContext.setSideBarHidden(true)
    console.log(showMenu)
  }
  return (
    <nav className="flex fixed top-0 justify-between px-4 bg-white h-16 w-full items-center z-20">
      <div onClick={() => setDisplaySidebar()} className='sm:hidden cursor-pointer'>
        <HamburgerSvg />
      </div>
      <div className="logoSize flex items-center">
        <img src={logo} alt='logo' className="h-full sm:mr-24 w-full object-cover" />
        <img onClick={() => setDisplaySidebar()} src={shrinkIcon} alt="shrink" className="hidden sm:block w-24 cursor-pointer mt-3" />
      </div>
      <div className= 'hidden sm:flex -mb-6' ><Tabs /></div>
      <div className="w-10 h-10" >
        <img src={studentPassport ? studentPassport : defaultPic} alt='logo' className="h-full w-full object-cover rounded-full" />
      </div>
    </nav>
  );
};

export default CbtNavbar;
